import { StyleSheet, Font } from "@react-pdf/renderer";
import { black, darkYellow, white } from "./PDFColors";
import fontSourceRegular from "../Fonts/AvenirNext/AvenirNextLTPro-Regular.otf";
import fontSourceItalic from "../Fonts/AvenirNext/AvenirNextLTPro-It.otf";
import fontSourceItalicHeavy from "../Fonts/AvenirNext/AvenirNextLTPro-HeavyIt.otf";
import fontSourceBold from "../Fonts/AvenirNext/AvenirNextLTPro-Bold.otf";

Font.register({
  family: "AvenirNext",
  fonts: [
    { src: fontSourceRegular },
    { src: fontSourceItalic, fontStyle: "italic" },
    { src: fontSourceItalicHeavy, fontStyle: "italic", fontWeight: "heavy" },
    {
      src: fontSourceBold,
      fontStyle: "normal",
      fontWeight: "bold",
    },
  ],
});

export const styles = StyleSheet.create({
  backgroundImage: {
    width: "841.89px",
    height: "595.28px",
  },

  title: {
    fontSize: "50px",
    color: white,
    fontFamily: "AvenirNext",
    fontStyle: "italic",
    fontWeight: "heavy",
  },
  titleContainer: {
    width: "841.89px",
    position: "absolute",
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "140px",
    alignItems: "center",
  },

  foundersContainer: {
    width: "841.89px",
    position: "absolute",
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "220px",
    alignItems: "center",
    textAlign: "center",
  },

  foundersText: {
    width: "450px",
    position: "absolute",
    color: darkYellow,
    fontFamily: "AvenirNext",
    fontStyle: "italic",
    fontWeight: "heavy",
    fontSize: "18px",
  },

  content: {
    position: "absolute",
    width: "841.89px",
    height: "595.28px",
  },

  poweredImage: {
    height: "50px",
    position: "absolute",
    right: "0%",
    bottom: "0%",
    marginBottom: "30px",
    marginRight: "30px",
  },

  Mace: {
    fontFamily: "Helvetica",
    fontSize: "30px",
    color: white,
    fontWeight: "bold",
    letterSpacing: "-1px",
  },

  CDContainer: {
    width: "200px",
    height: "120px",
    position: "absolute",
    left: "0%",
    bottom: "0%",
    marginBottom: "30px",
    marginLeft: "30px",
  },

  CDTop: {
    backgroundColor: black,
    width: "200px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  CDTopText: {
    position: "absolute",
    color: white,
    fontFamily: "AvenirNext",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "17px",
  },

  CDMiddle: {
    backgroundColor: white,
    width: "200px",
    height: "40px",
    color: black,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  CDMiddleText: {
    position: "absolute",
    color: black,
    fontFamily: "AvenirNext",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "17px",
  },

  CDBottom: {
    backgroundColor: black,
    width: "200px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  CDBottomText: {
    position: "absolute",
    color: white,
    fontFamily: "AvenirNext",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "17px",
  },
});
